
<!-- 维普问卷页面 --侧边栏 -->
<template>
    <main class="psq-wrapper">
        <manage-title>问卷管理</manage-title>
        <section class="psq-content">
            <el-row class="psq-content--header">
                <search-form  @search="onSearch" style="float: left"/>
                <el-button type="default"
                           icon="el-icon-delete"
                           @click.stop="handleOpenRecycleBin"
                           size="small" style="float: right">回收站</el-button>
            </el-row>
            <el-row type="flex" class="psq-content--card-list" justify="space-between">
                <el-card v-if="$store.state.isCheckEnd" body-style="text-align: center;
                                    padding: 20px;
                                    box-sizing: border-box;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    height: 100%"
                         @click.native.stop="handleCreateProject"
                         class="list-item">
                    <img src="@/assets/img/psq/sidebar-psq/add-three.png"
                         alt="add-icon"
                         width="35" height="35"
                         style="vertical-align: middle; margin-right: 20px"/>
                    <span class="card-new--project">新建项目</span>
                </el-card>
                <template v-show="questionList.length">
                    <card v-for="(item, index) in questionList"
                          :key="item.id"
                          :index="index" :item="item" :length="questionList.length"/>
                </template>
            </el-row>
        </section>
        <el-empty description="暂无问卷" v-show="questionList.length === 0"/>
        <pagination :p-size.sync="pageSize"
                    :page-no.sync="pageIndex"
                    :page-sizes="[11, 20, 33, 41]"
                    @change="getQuestionList"
                    :total="total"/>
        <recycle-bin ref="recycleBin"/>
    </main>
</template>

<script>
import ManageTitle from "@/components/manager/ManageTitle";
// 搜索表单
import SearchForm from "./cpns/form"
// card列表
import Card from "./cpns/card"
import { getQuestionList } from "@/api/new-question-iteration/question-library"
import Pagination from "@/components/Pagination";
// 回收站
import RecycleBin from "./cpns/recycleBin";
export default {
    name: "AdminPsq",
    componentName: "AdminSidebarPsq",
    components: {
        Pagination,
        ManageTitle,
        SearchForm,
        Card,
        RecycleBin
    },
    data () {
        return {
            isShowActionsMap: {},
            questionList: [],
            pageSize: 11,
            pageIndex: 1,
            total: 10
        }
    },
    created() {
        this.getQuestionList()
    },
    methods: {
        // 处理搜索
        onSearch (val) {
            this.searchVal = val
            this.pageIndex = 1
            this.getQuestionList(val)
        },
        // 处理创建问卷
        handleCreateProject () {
            this.$router.push("/manage/msq/create")
        },
        // 获取问卷列表
        getQuestionList (searchVal = this.searchVal) {
            const { pageSize, pageIndex } = this
            getQuestionList({
                pageSize,
                pageIndex,
                ...(searchVal || Object.create(null))
            }).then(res => {
                this.questionList = res.data
                this.total = res.count
            })
        },
        // 打开回收站弹窗
        handleOpenRecycleBin () {
            this.$refs.recycleBin.open()
        }
    }
}
</script>

<style scoped lang="less">
@import "index";
.psq-content--card-list {
    flex-wrap: wrap;
}
.psq-wrapper {
    min-height: 700px;
    width: 100%;
    background: #fff;
    border-radius: 16px;
    margin: 0 auto 30px;

}
.psq-content {
    padding: @--base-padding;
    &--header {
        margin-bottom: @--base-padding;
    }
}

.card-new--project {
    color: @--color-primary;
    font-size: 16px;
    position: relative;
    top: 2px;
}
</style>
